import React, { useEffect, useState } from "react";
import { FaBook, FaLayerGroup, FaArrowRight } from "react-icons/fa";
import studentAxios from "../constants/studentAxios";

const Subjects = () => {
  const studentId = localStorage.getItem("studentId");
  const sessionId = localStorage.getItem("currentSessionId");

  const [student, setStudent] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ---------------- FETCH STUDENT ---------------- */
  useEffect(() => {
    if (!studentId) return;

    const fetchStudent = async () => {
      try {
        const res = await studentAxios.get(
          `/students/getStudents/${studentId}`,
          { params: { sessionId } }
        );
        setStudent(res.data);
      } catch (err) {
        console.error("Error fetching student:", err);
      }
    };

    fetchStudent();
  }, [studentId]);

  /* ---------------- FETCH SUBJECTS (SESSION-BASED) ---------------- */
  useEffect(() => {
    if (!student || !sessionId) return;

    const fetchSubjects = async () => {
      try {
        const res = await studentAxios.get(
          `/subjects/getSubjectsByClassName/${encodeURIComponent(
            student.class
          )}`,
          { params: { sessionId } }
        );
        setSubjects(res.data);
      } catch (err) {
        console.error("Error fetching subjects:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSubjects();
  }, [student, sessionId]);

  /* ---------------- LOADING ---------------- */
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen text-lg font-semibold">
        Loading…
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 md:p-6">
      {/* ---------------- EMPTY STATE ---------------- */}
      {subjects.length === 0 ? (
        <div className="flex flex-col justify-center items-center bg-white shadow-md rounded-lg p-8 mt-10">
          <FaBook className="text-gray-400 text-6xl mb-4 animate-bounce" />
          <p className="text-gray-600 text-lg">
            No subjects assigned for this session.
          </p>
        </div>
      ) : (
        <>
          {/* ---------------- HEADER ---------------- */}
          <div className="mb-6">
            <h1 className="text-xl font-bold text-gray-800 flex items-center gap-2">
              <FaLayerGroup className="text-indigo-600" />
              Subjects
            </h1>
            <p className="text-sm text-gray-500 mt-1">
              Class {student.class} – Section {student.section}
            </p>
          </div>

          {/* ---------------- GRID ---------------- */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {subjects.map((subject, index) => (
              <div
                key={index}
                className="p-6 bg-white rounded-xl shadow-lg hover:shadow-2xl transition-transform transform hover:-translate-y-1 hover:scale-[1.02]"
              >
                <div className="flex items-center gap-4">
                  <div className="p-3 rounded-full bg-indigo-100 text-indigo-600">
                    <FaBook />
                  </div>

                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-800">
                      {subject.subjectName}
                    </h3>
                    <p className="text-sm text-gray-500">
                      Academic Subject
                    </p>
                  </div>

                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Subjects;
